import { Button, Space } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

/** Phase 2B-2 §7.2/Case 7 — the multi-select batch action bar, extracted
 * out of `Home.tsx`'s inline JSX so the standalone asset list and the SaaS
 * Workspace Images page offer the exact same batch actions
 * (批量重新生成透明底图 / 批量重跑全部流程 / 批量删除), each scoped by the
 * caller's own `selected` ids — which, in the SaaS case, only ever contains
 * ids already filtered to that Workspace's own `/chains` list.
 *
 * `onBatchDownload` (Image Assets UX release, spec 一.2) is the one new,
 * optional action here — omitted by `Home.tsx` (standalone product, out of
 * this release's scope), wired only by the SaaS Images page. */
export default function SelectionActionBar({
  count,
  onRetryTransparent,
  onReprocess,
  onDelete,
  onClear,
  onBatchDownload,
  batchDownloading,
}: {
  count: number
  onRetryTransparent: () => void
  onReprocess: () => void
  onDelete: () => void
  onClear: () => void
  onBatchDownload?: () => void
  batchDownloading?: boolean
}) {
  const { t } = useTranslation('autoProcess')

  if (count <= 0) return null
  return (
    <div className="panel selection-bar">
      <Space wrap>
        <span>{t('selection.count', { count })}</span>
        {onBatchDownload && (
          <Button
            size="small"
            icon={<DownloadOutlined />}
            loading={batchDownloading}
            onClick={onBatchDownload}
            data-testid="batch-download-btn"
          >
            {t('selection.batchDownload')}
          </Button>
        )}
        <Button size="small" onClick={onRetryTransparent} data-testid="batch-retry-transparent-btn">
          {t('selection.retryTransparent')}
        </Button>
        <Button size="small" onClick={onReprocess} data-testid="batch-reprocess-btn">
          {t('selection.reprocess')}
        </Button>
        <Button size="small" danger onClick={onDelete} data-testid="batch-delete-btn">
          {t('selection.delete')}
        </Button>
        <Button size="small" onClick={onClear} data-testid="batch-clear-btn">
          {t('selection.clear')}
        </Button>
      </Space>
    </div>
  )
}
